import { render, staticRenderFns } from "./SAFormLabel.html?vue&type=template&id=82ab0c64&scoped=true&"
import script from "./SAFormLabel.ts?vue&type=script&lang=ts&"
export * from "./SAFormLabel.ts?vue&type=script&lang=ts&"
import style0 from "./SAFormLabel.css?vue&type=style&index=0&id=82ab0c64&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82ab0c64",
  null
  
)

export default component.exports